import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { setRequestError } from "redux/system/system.actions";
import { Button, Input, Form, Upload, Icon, message } from "antd";

import http from "services/httpService";
import { apiUrl, cwaUploadRootDir } from "config.json";

//axios cancellation
const CancelToken = http.CancelToken;
let CancelRequest = undefined;

const AddVideoForm = ({
    onSubmit,
    userID,
    ownerID,
    clinicID,
    uploadServer,
    uploadEndpoint,
}) => {
    const [formData, setFormData] = useState({
        name: "",
        filename: "",
        url: "",
        video_size: 0,
        user_id: userID,
        clinic_id: clinicID,
    });
    const [formErrors, setFormErrors] = useState({
        name: "",
        url: "",
    });

    const [videoFile, setVideoFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    useEffect(() => {
        return () => {
            if (CancelRequest) {
                CancelRequest({
                    responseCancelled: true,
                });
            }
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleInputBlur = (e) => {
        let errors = { ...formErrors };
        if (e.target.value.trim() !== "") {
            errors[e.target.name] = "";
        }
        setFormErrors(errors);
    };

    const validateInput = () => {
        const { name } = formData;
        let errors = {};

        if (name.trim() === "") {
            errors.name = "Name is required";
        }

        return Object.keys(errors).length === 0 ? null : errors;
    };

    const handleSubmit = async (e) => {
        const errors = validateInput();
        if (errors) {
            setFormErrors(errors);
        } else if (!videoFile) {
            message.error("Please select a video file");
        } else {
            try {
                setIsUploading(true);
                const fd = new FormData();
                fd.append("uniFile", videoFile);

                const response = await http.post(
                    `${apiUrl}/queueingVideo`,
                    fd,
                    {
                        params: {
                            space_server: uploadServer,
                            space_bucket_name: uploadEndpoint,
                            root_dir: cwaUploadRootDir,
                            owner_id: ownerID,
                            clinic_id: clinicID,
                        },
                        cancelToken: new CancelToken(function executor(c) {
                            CancelRequest = c;
                        }),
                    }
                );

                if (response.data.error) {
                    message.error("Upload failed please try again.");
                    setIsUploading(true);
                } else {
                    const { newFilename } = response.data;

                    setIsUploading(false);
                    onSubmit({
                        ...formData,
                        filename: newFilename,
                        url: `https://${uploadServer}/${uploadEndpoint}/${cwaUploadRootDir}/system/${ownerID}/clinics/${clinicID}/videos/queueing/${newFilename}.mp4`,
                        video_size: videoFile.size,
                    });
                }
            } catch (error) {
                if (!error.message.responseCancelled) {
                    setRequestError({
                        errorMessage:
                            "Something went wrong on your last operation :(",
                        errorSubMessage: error.message,
                    });
                }
            }
        }
    };

    const uploadProps = {
        showUploadList: false,
        beforeUpload: (file) => {
            const isValidFile = file.type === "video/mp4";
            if (!isValidFile) {
                message.error("You can only upload video in mp4 format!");
            }
            const isValidSize = file.size / 1024 / 1024 < 10;
            if (!isValidSize) {
                message.error("File must smaller than 10MB!");
            }
            if (isValidFile && isValidSize) {
                setVideoFile(file);
                return false;
            } else {
                return false;
            }
        },
    };

    return (
        <Form>
            <Form.Item
                label="Enter video name"
                required={true}
                hasFeedback={true}
                validateStatus={formErrors.name && "error"}
                help={formErrors.name && formErrors.name}
            >
                <Input
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                />
            </Form.Item>
            <Upload {...uploadProps}>
                <Button>
                    <Icon type="upload" /> Upload
                </Button>
            </Upload>
            <div>{videoFile && videoFile.name}</div>
            <Form.Item>
                <Button
                    type="primary"
                    loading={isUploading}
                    style={{ marginTop: 10 }}
                    onClick={handleSubmit}
                >
                    {isUploading ? "Uploading" : "OK"}
                </Button>
            </Form.Item>
        </Form>
    );
};

const mapStateToProps = (state) => ({
    userID: state.UserDetails.user_id,
    ownerID: state.UserDetails.owner_id,
    clinicID: state.UserDetails.clinicDetails.clinic_id,
    uploadServer: state.UserDetails.uploadDetails.server,
    uploadEndpoint: state.UserDetails.uploadDetails.endpoint,
});

const mapDispatchToProps = (dispatch) => ({
    setRequestError: (data) => dispatch(setRequestError(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddVideoForm);
